import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';

import { AppComponent } from './app.component';
import { HeadquarterModule } from './headquarter/headquarter.module';
import { StatisticalDataModule } from './headquarter/statistical-data/statistical-data.module';
import { HttpClientModule } from '@angular/common/http';
import { ReactiveFormsModule } from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { ManagementDashboardModule } from './headquarter/management-dashboard/management-dashboard.module';
// import { GrievanceModule } from './headquarter/grievance/grievance.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
// import { ScrollDirective } from './scroll.directive';



@NgModule({
  declarations: [
    AppComponent,
    // ScrollDirective
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HeadquarterModule,
    StatisticalDataModule,
    ManagementDashboardModule,
    // GrievanceModule,
    BrowserAnimationsModule,
    HttpClientModule,
    ReactiveFormsModule,
    FormsModule,
    NgbModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
